import React, { Component } from 'react'
import PropTypes from 'prop-types'
import UUID from 'uuid'
import { push } from 'react-router-redux'
import AppStore from '../../store/AppStore'

class SwitchPanel extends Component {
	constructor(props) {
		super(props)
		this.state = {
			checked: props.checked
		}
		this.toggleCheck = this.toggleCheck.bind(this)
		this.onClick = this.onClick.bind(this)
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.checked !== this.state.checked) {
			this.setState({
				checked: nextProps.checked
			})
		}
	}

	toggleCheck() {
		this.props.onToggleCheck()
		this.setState({
			checked: !this.state.checked
		})
	}

	onClick() {
		if (this.props.link) {
			AppStore.dispatch(push(`/${this.props.link}`))
		}
	}

	render() {
		const id = UUID.v4()
		return (
			<div className='row no-margin'>
				<div className='col s12'>
					<div className='row no-margin valign-wrapper'>
						<div className='col s1 no-padding '>
							<div className='switch'>
								<label htmlFor={ id }>
									<input checked={ this.state.checked } onChange={ this.toggleCheck } type='checkbox'
										   id={ id }/>
									<span className='lever'/>
								</label>
							</div>
						</div>
						<div className='col s11 padding-left-20' onClick={ this.onClick }>
							{ this.props.children }
						</div>
					</div>
				</div>
			</div>
		)
	}
}

SwitchPanel.propTypes = {
	onToggleCheck: PropTypes.func,
	children: PropTypes.element,
	checked: PropTypes.bool,
	link: PropTypes.string
}

SwitchPanel.defaultProps = {
	onToggleCheck: () => {
	},
	children: '',
	checked: true,
	link: ''
}

export default SwitchPanel



// WEBPACK FOOTER //
// ./src/components/panel/SwitchPanel.js